import { HugeiconsIcon } from "@hugeicons/react";
import { Tick02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { cx } from "shared/utils";

export const PaywallHighlights = ({
  highlights,
  className
}: {
  highlights: readonly string[];
  className?: string;
}) => (
  <ul className={cx("space-y-1.5 pt-1", className)}>
    {highlights.map((highlight) => (
      <li
        key={highlight}
        className="flex items-center gap-2 text-sm font-medium text-content-1000"
      >
        <HugeiconsIcon
          icon={Tick02Icon}
          size={16}
          className="shrink-0 text-success-700"
        />
        {highlight}
      </li>
    ))}
  </ul>
);
